import React, { Component } from 'react';
import PropTypes from 'prop-types';
import objectAssign from 'object-assign';

const BookingOverviewHOC = (C) => {
  class BookingOverviewCont extends Component {
    static show(props) {
      return props.appearance.isNarrow;
    }

    constructor(props) {
      super(props);
      this.toggleBookingOverview = this.toggleBookingOverview.bind(this);
      this.setBookingOverviewExpanded = this.setBookingOverviewExpanded.bind(this);
    }

    componentWillMount() {
      this.setBookingOverviewExpanded();
    }

    setBookingOverviewExpanded() {
      return this.props.order.adults === 0 ? this.props.actions.updateBookingOverview(true) : this.props.actions.updateBookingOverview(false);
    }

    getPaymentValidator() {
      return () => {
        const order = objectAssign({},
          this.props.order);
        const appearance = objectAssign({},
          this.props.appearance);
        this.props.actions.firePayButtonClick(true);
        this.props.validatorFactory().then(factory => factory.getGlobalValidator())
          .then(validator => validator(order,
            appearance))
          .then(
            (updatedOrder) => {
              // Validation of terms and conditions is not part of orderValidator, so it is not in globalValidator,
              // but it still has to prevent payment process and fire validation errors.
              if (!this.props.appearance.acceptedTermsAndConditions) {
                this.props.actions.termsError('You have to accept Terms and Conditions');
                this.props.actions.startSubmitLoading(false);
              }
              else {
                this.props.actions.termsError('');
                this.props.actions.pay(updatedOrder);
              }
            }
          )
          .catch(
            // Validation errors.
            () => {
              this.props.dispatchScrollToInvalid();
              this.props.actions.startSubmitLoading(false);
            }
          );
      };
    }

    toggleBookingOverview() {
      return this.props.actions.updateBookingOverview(!this.props.appearance.bookingOverviewExpanded);
    }

    render() {
      return (
        <C
          actions={this.props.actions}
          appearance={this.props.appearance}
          errors={this.props.errors}
          main={this.props.main}
          onToggle={this.toggleBookingOverview}
          order={this.props.order}
          paymentValidate={this.getPaymentValidator()}
          rental={this.props.rental}
          termsAndConditions={this.props.appearance.termsAndConditionsLink}
        />
      );
    }
  }

  BookingOverviewCont.PropTypes = {
    main:PropTypes.bool,
    dispatchScrollToInvalid:PropTypes.func,
    appearance:PropTypes.object.isRequired,
    order:PropTypes.object.isRequired,
    rental:PropTypes.object.isRequired,
    errors:PropTypes.object.isRequired,
    actions:PropTypes.object.isRequired,
    validatorFactory:PropTypes.object.isRequired,
  };

  return BookingOverviewCont;
};

export default BookingOverviewHOC;
